
import { mapState } from 'vuex';
import HorizontalScroll from './components/HorizontalScroll.vue';

export default {
  i18nComponentKey: 'WidgetCategoryReviewsHorizontalScroll.WidgetCategoryReviewsHorizontalScrollMobile',
  name: 'WidgetCategoryReviewsHorizontalScrollMobile',
  components: { HorizontalScroll },
  computed: {
    ...mapState('widget', ['widget']),
    horizontalScrollProps() {
      return this.layoutProps;
    },
    layoutProps() {
      switch (this.widget.posts_per_line) {
        case 2:
          return { cols: 2, productImageSize: 32 };
        case 3:
          return { cols: 3, productImageSize: 28 };
        default:
          return { cols: 1, productImageSize: 40 };
      }
    }
  }
};
